<template>
  <div class="newsNew" >
    <div class="news-center-filter">
      <z-segment
        v-if="columnList.length"
        round
        :value="this.currentCategory.id || ''"
        :props="props"
        :options="columnList"
        :max-length="maxLength"
        style="font-weight: bold"
        @change="(value, index) => tabsChange(value, index)"
      />
      <div class="news-center-filter-mode" @click="modeChange" v-if="columnList.length && this.currentCategory.columnCode !== 'totalPreview'" style="display: none">
        <transition name="scale-in-center" mode="out-in">
          <span>
            <i
              class="el-icon-menu"
              v-if="displayModeWatch === 'list'"
              key="card"
            ></i>
            <i class="el-icon-s-fold" v-else key="list"></i>
          </span>
        </transition>
      </div>
    </div>
    <div class="newsNew-main-content"  element-loading-background="rgba(0, 0, 0, 0)"
    >
      <template v-if="newsOverPreviewList.length > 0 && currentCategory.columnCode === 'totalPreview' " >
        <template v-if="!screenSizeMore1720">
          <div class="newsNew-main-content-top flex flex-wrap">
            <div class="flex flex-between" style="width: 100%">
              <NewsModule :style-obj="styleSetting1[0]" class="mr20"  :data="newsOverPreviewList[0]"  @go-to-news-detail = "goToNewsDetail" :moduleIndex="0" :loading="loadingsPreview[columnList[1].id]">
                <NewsHeader slot="module-header" :data = "columnList[1]" @getMore="getMore" />
              </NewsModule>
              <NewsModule  :style-obj="styleSetting1[1]" :data="newsOverPreviewList[1]" mode="pic"  @go-to-news-detail = "goToNewsDetail" :moduleIndex="1" :loading="loadingsPreview[columnList[2].id]">
                <NewsHeader slot="module-header" :data = "columnList[2]" @getMore="getMore" />
              </NewsModule>
            </div>
            <div class="mt20" style="width: 100%">
              <NewsRowModule   :style-obj="styleSetting1[2]" :data="newsOverPreviewList[2]" mode="pic"  @go-to-news-detail = "goToNewsDetail" :moduleIndex="2" noDataType="center" :loading="loadingsPreview[columnList[3].id]">
                <NewsHeader slot="module-header" :data = "columnList[3]" @getMore="getMore" />
              </NewsRowModule>
            </div>
            <div>
            </div>
          </div>
          <div class="newsNew-main-content-bottom" >
            <div class="newsNew-main-content-bottom-modules" v-for=" (newItem,newKey) in newsOverPreviewList.slice(3)" :moduleIndex="(newKey + 3)" :key="newKey">
              <NewsModule style="flex:1" :style-obj="styleSetting1[newKey+3]"   :data="newItem" mode="pic"  @go-to-news-detail = "goToNewsDetail" :loading="loadingsPreview[columnList[newKey+4].id]">
                <NewsHeader slot="module-header" :data = "columnList[newKey+4]" @getMore="getMore" />
              </NewsModule>
            </div>
          </div>
          <!--          <div class="newsNew-main-content-bottom">-->
          <!--            <NewsModule class="newsNew-main-content-bottom-modules" :style-obj="styleSetting1[newKey+3]"  :key="newKey" :data="newItem.slice(0,7)" mode="pic"  @go-to-news-detail = "goToNewsDetail">-->
          <!--              <NewsHeader slot="module-header" :data = "columnList[newKey+((newsOverPreviewList.length)%2 === 0 ? 3 : 4)]"  @getMore="getMore" :showMore="newItem.length > 7"/>-->
          <!--            </NewsModule>-->
          <!--          </div>-->
        </template>
        <template v-else>
          <div class="newsNew-main-content-top">
            <div >
              <NewsModule :style-obj="styleSetting[0]" class="newsNew-content-left" :data="newsOverPreviewList[0]"  @go-to-news-detail = "goToNewsDetail" :loading="loadingsPreview[columnList[1].id]" :moduleIndex="0">
                <NewsHeader slot="module-header" :data = "columnList[1]" @getMore="getMore" />
              </NewsModule>
            </div>
            <div class="newsNew-content-right">
              <NewsModule class="newsNew-content-right-first" :style-obj="styleSetting[1]" :data="newsOverPreviewList[1]" mode="pic"  @go-to-news-detail = "goToNewsDetail"  :moduleIndex="1" :loading="loadingsPreview[columnList[2].id]">
                <NewsHeader slot="module-header" :data = "columnList[2]" @getMore="getMore" />
              </NewsModule>
              <NewsModule class="" :style-obj="styleSetting[2]" :data="newsOverPreviewList[2]" mode="pic"  @go-to-news-detail = "goToNewsDetail" :moduleIndex="2" :loading="loadingsPreview[columnList[3].id]">
                <NewsHeader slot="module-header" :data = "columnList[3]" @getMore="getMore" />
              </NewsModule>
              <NewsRowModule class="newsNew-content-right-last" :style-obj="styleSetting[3]" :data="newsOverPreviewList[3]" mode="pic"  @go-to-news-detail = "goToNewsDetail" :moduleIndex="3" noDataType="center" :loading="loadingsPreview[columnList[4].id]">
                <NewsHeader slot="module-header" :data = "columnList[4]" @getMore="getMore" />
              </NewsRowModule>
            </div>
          </div>
          <div class="newsNew-main-content-bottom">
            <NewsModule :style-obj="styleSetting[newKey+4]" class="newsNew-main-content-bottom-modules" v-for=" (newItem,newKey) in newsOverPreviewList.slice(4)"
                        :key="newKey" :data="newItem" mode="pic"
                        @go-to-news-detail = "goToNewsDetail" :moduleIndex="(newKey + 4)" :loading="loadingsPreview[columnList[newKey+5].id]">
              <NewsHeader slot="module-header" :data = "columnList[newKey+5]" @getMore="getMore" />
            </NewsModule>
          </div>
        </template>
      </template>
      <template v-if="currentCategory.columnCode !== 'totalPreview' && displayModeWatch === 'list'">
        <childNewsList
          :data="newsList"
          :pageNo = "pageNo"
          :pageSize = "pageSize"
          :totalCount = "totalCount"
          :loading = "loading1"
          :columnName = "this.currentCategory.columnName"
          :columnId = "this.currentCategory.id"
          @go-to-news-detail = "goToNewsDetail"
          @search-more = "searchMore"
        />
      </template>
      <template v-if="currentCategory.columnCode && currentCategory.columnCode !== 'totalPreview' && displayModeWatch === 'card'">
        <childNewsCard :data="newsList"
                       :loading = "loading1"
                       :pageNo = "pageNo"
                       :pageSize = "pageSize"
                       :totalCount = "totalCount"
                       :columnName = "this.currentCategory.columnName"
                       @go-to-news-detail = "goToNewsDetail"/>
      </template>
    </div>

  </div>
</template>
<script>
  import NewsHeader from './newsHeader.vue';
  import NewsModule from './newsModule.vue';
  import NewsRowModule from './newsRowModule.vue';
  import childNewsList from './childNewsList.vue';
  import childNewsCard from './childNewsCard.vue';
  import { getNewsColumn, getNewsList, getTotalNewsList,getNewsContent, getRssContent,writeReadRecord } from "@/api/news";
  import { ifNewVisit } from '@/utils/utils.js'
  import request from '@/utils/request';
  import configR from '@/configs.js';
  export default {
    name: "NewsNew",
    components: {
      NewsHeader,
      NewsModule,
      childNewsList,
      childNewsCard,
      NewsRowModule
    },
    props: {
      minWidth: Number,
      maxWidth: Number,
      minHeight: Number,
      maxHeight: Number,
      bgColor: {type:String, default:'rgba(235, 152, 122,0.86)'},
      blurBackgroundImg: {type: String, default:require('@/assets/Home/Sticker/news.jpg')},
      contentVisibleStu: {type:Boolean, default:false},
      sequence: {type:Number}
    },

    data() {
      return {
        request:request,
        serveUrl:configR.envConfigs.PORTAL_API,
        // 总览栏目下，控制各个模块loading
        loadingsPreview: {},
        // 栏目
        columnList: [],
        // 当前栏目
        currentCategory: {},
        //
        currentTab: 0,
        //
        newsList: [],
        newColumnId:'',
        newsOverPreviewList: [],
        // 新闻页数
        pageNo: 1,
        // 新闻数量
        pageSize: 10,
        // 新闻总数量
        totalCount: 0,
        newsContent: null,
        //
        newsContentVisible: false,
        props: {
          value: "id",
          label: "columnName"
        },
        maxLength: 10,
        // 栏目更多是否显示
        tabsMoreShow: false,
        activeIndexs: [],
        loading1: false,
        displayModeWatch: 'list',
        moduleHeight: 860, // 模块高度
        heightSetting: {
          headerHeight: 84,
          bigScreen: {firstModuleHeight: 1300},
          smallScreen: {firstModuleHeight: 860},
          commonModuleHeight: 860
        },
        styleSetting: [{width:'546px',height:'1300px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'1112px',height:'416px'},
          {width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},
          {width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'},{width:'546px',height:'860px'}],
        screenSizeMore1720: true,
        styleSetting1:[{width:`calc(50% - 10px)`,height:'860px'},{width:`calc(50% - 10px)`,height:'860px'},{width:'100%',height:'449px'},{flex:1,height:'860px'},{flex:1,height:'860px'},
          {flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},
          {flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},
          {flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'},{flex:1,height:'860px'}]
      };
    },
    created() {
      // 判断设备是否是window
      // let agent = navigator.userAgent.toLowerCase();
      // if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0 || agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
      //   this.serviceType = 'window'
      // } else {
      //   this.serviceType = 'mac'
      // }

      let clientWidth = document.documentElement.clientWidth;
      this.screenSizeMore1720 =clientWidth >= 1720;

      this.maxLength = this.screenSizeMore1720 ? 12 : !this.screenSizeMore1720 && clientWidth > 1580 ? 11 : clientWidth <= 1580 &&  clientWidth >= 1400 ? 10:  clientWidth < 1400 &&  clientWidth >= 1300 ?  9 : clientWidth < 1300 &&  clientWidth >= 1200 ?  8 :  clientWidth < 1200 &&  clientWidth >= 1100 ?  7 : 6;
      //fromRouter 从资讯中心路由首位处添加的参数
      if(this.$route.params.fromRouter) {
        this.newColumnId = '';
      }else {
        this.newColumnId = this.$store.state.user.newColumnId;
      }
      this.handleGetNewsColumn();
      window.onresize= ()=> {
        let clientWidth = document.documentElement.clientWidth;
        this.screenSizeMore1720 =clientWidth >= 1720;
        this.maxLength = this.screenSizeMore1720 ? 12 : !this.screenSizeMore1720 && clientWidth > 1580 ? 11 : clientWidth <= 1580 &&  clientWidth >= 1400 ? 10:  clientWidth < 1400 &&  clientWidth >= 1300 ?  9 : clientWidth < 1300 &&  clientWidth >= 1200 ?  8 :  clientWidth < 1200 &&  clientWidth >= 1100 ?  7 : 6;
      }
    },
    methods: {
      searchMore(data){
        this.pageNo = data.pageNo;
        this.pageSize = data.pageSize;
        this.getNewsList(this.currentCategory);
      },
      modeChange(){
        this.displayModeWatch = this.displayModeWatch === 'list' ? 'card' : 'list';
      },
      async writeReadRecord(newsItem,newsIndex,moduleIndex){
        let data = {contentId:newsItem.id, request: this.request,
          serveUrl: this.serveUrl,
          header: "portal"}
        try{
          let res = await writeReadRecord(data);
          // 记录接口返回为'1'时，前端浏览量数量处理+1
          if(res.code === 0 && res.data === '1') {
            // 总览
            if(this.currentCategory.columnCode === 'totalPreview') {
              let readCount = this.newsOverPreviewList[moduleIndex][newsIndex].readCount;
              readCount = readCount ? Number(readCount) + 1 : 0
              this.$set(this.newsOverPreviewList[moduleIndex][newsIndex],'readCount',readCount);
            }else {
              let readCount =this.newsList[newsIndex].readCount;
              readCount = readCount ? Number(readCount) + 1 : 0
              this.$set(this.newsList[newsIndex],'readCount',readCount);
            }
          }
        }catch (e) {}

      },
      goToNewsDetail(newsItem,newsIndex,moduleIndex){
        this.writeReadRecord(newsItem,newsIndex,moduleIndex);
        if(newsItem.url) {
          window.open(newsItem.url)
          return false;
        }
        let a = this.$router.resolve({ name: "NewsDetail", query: { id: newsItem.id,columnId:newsItem.columnId } })
        window.open(a.href)
      },
      // 点击更多
      getMore(columnId){
        if(!columnId) {
          this.$message.error('无栏目ID');
          return false;
        }
        this.currentCategory = (this.columnList.filter( item => item.id === columnId))[0];
        this.loading1 = false;
        this.newsList = [];
        this.newsOverPreviewList = [];
        this.pageNo = 1;
        this.getNewsList(this.currentCategory);
      },
      // 获取新闻栏目
      async handleGetNewsColumn() {
        let data = {
          request: this.request,
          serveUrl: this.serveUrl,
          header: "portal"
        };
        let res = await getNewsColumn(data);
        if(res.data) {
          this.columnList = res.data;
          if(this.columnList.length >= 4) {
            this.columnList.unshift({columnName: '总览', id: '', columnCode:'totalPreview'});
          }
          // 非总览
          if(this.newColumnId) {
            let currentCategory = this.columnList.filter(item => item.id === this.newColumnId);
            if(currentCategory && currentCategory.length > 0) {
              this.currentCategory = currentCategory[0]
            }else {
              this.currentCategory = this.columnList[this.currentTab];
            }

          } else {
            this.currentCategory = this.columnList[this.currentTab];
            // 总览
            if (this.currentCategory.columnCode === 'totalPreview') {
              let columnList = this.columnList.slice(1);
              columnList.map( columnItem => {
                this.newsOverPreviewList.push([]);
                this.loadingsPreview[columnItem.id] = true;
                if(columnItem.id.indexOf('remote-') > -1) {
                  this.getNewsListFromTotalPreview(columnItem)
                }
              })
            }
          }
          this.getNewsList(this.currentCategory);
        }
      },
      // 标签切换
      tabsChange(value, index) {
        this.loading1 = false;
        this.currentTab = index;
        this.activeIndexs = [];
        this.currentCategory = this.columnList[index]
        this.newsList = [];
        this.newsOverPreviewList = [];
        this.pageNo = 1;
        console.log('this.currentCategory.columnCode',this.currentCategory.columnCode)
        if (this.currentCategory.columnCode === 'totalPreview') {
          let columnList = this.columnList.slice(1);
          columnList.map( columnItem => {
            this.newsOverPreviewList.push([]);
            this.loadingsPreview[columnItem.id] = true;
            if(columnItem.id.indexOf('remote-') > -1) {
              this.getNewsListFromTotalPreview(columnItem)
            }
          })
        }
        this.getNewsList(this.currentCategory);
        this.$store.commit("SET_COLUMN_ID",this.currentCategory.id);
      },
      // 获取新闻列表
      getNewsList(columnData){
        if(columnData && columnData.rss) {
          this.getJumpUrlNewsList(columnData);
        } else if(columnData.columnCode === 'totalPreview') {
          this.getTotalNewsList(columnData);
        }else {
          this.handleGetNewsList(columnData);
        }

      },
      // 总览栏目获取资讯
      getTotalNewsList(){
        let data = {
          request: this.request,
          serveUrl: this.serveUrl,
          ColumnId: this.currentCategory.id || "",
          kw: "",
          pageNo: this.pageNo,
          pageSize:20,
          loadContent: false,
          loadPicContents: true,
          header: "portal"
        };
        getTotalNewsList(data).then(res => {
          if (res.data && res.data.allContents) {
            let allContents = res.data.allContents;
            this.totalCount = res.data.count;
            if(this.currentCategory.columnCode === 'totalPreview') {
              this.columnList.slice(1).map( columnItem => {
                if(columnItem.id.indexOf('remote-') === -1) {
                  this.loadingsPreview[columnItem.id] = false;
                }
              })
              let ifPreviewData = false;
              if(!allContents || allContents.length === 0) {
                return false;
              }
              let firstColumnId = this.columnList[1].id;
              allContents.forEach( item=> {
                item.isNewNews = ifNewVisit(item.releaseStartTime,new Date().getTime(), 3*24*60*60*1000);
                item.releaseStartTime = item.releaseStartTime && item.releaseStartTime.replace(/-/g, '/') || '';
                if(item.columnId !== firstColumnId ) {
                  ifPreviewData = true
                }
              })
              if(!ifPreviewData) {
                return false;
              }

              let columnList = this.columnList.slice(1);
              columnList.forEach( (columnItem,columnIndex) => {
                let filterArr = allContents.filter( contentItem => columnItem.id === contentItem.columnId);
                // 纵览接口返回数据，栏目ID包含remote-，重新请求该栏目接口
                if(columnItem.id.indexOf('remote-') === -1) {
                  let model = columnIndex === 0 ? 'simple' : '';
                  //第一栏如果是小屏幕尺寸取this.heightSetting.smallScreen.firstModuleHeight，否则取this.heightSetting.bigScreen.firstModuleHeight，非第一屏取commonModuleHeight
                  let moduleHeight = columnIndex === 0 ? this.screenSizeMore1720 ? this.heightSetting.bigScreen.firstModuleHeight : this.heightSetting.smallScreen.firstModuleHeight: this.heightSetting.commonModuleHeight;
                  this.newsOverPreviewList.splice(columnIndex, 1, this.getComputedNewsList(filterArr,moduleHeight,model))
                }
              })
            }
          } else {
            if(this.currentCategory.columnCode === 'totalPreview') {
              this.columnList.slice(1).map( columnItem => {
                if(columnItem.id.indexOf('remote-') === -1) {
                  this.loadingsPreview[columnItem.id] = false;
                }
              })
            }
          }

        });
      },
      getComputedNewsList(totalNewsList, moduleHeight,model){
        if(!totalNewsList || totalNewsList.length === 0) { return []};
        let totalUnit = 0
        let bodyHeight = moduleHeight-this.heightSetting.headerHeight;
        let computedNumber = 0
        for(let i = 0; i < totalNewsList.length; i++) {
          if(model !== 'simple' && (totalNewsList[i].titleImage || totalNewsList[i].contentDesc) && i < 3) {
            totalUnit = totalUnit + 2;
          } else {
            totalUnit = totalUnit + 1;
          }
          computedNumber = i
          if(bodyHeight < totalUnit * 73 ){
            computedNumber = i-1;
            break;
          }


        }
        return totalNewsList.slice(0,computedNumber+1);
      },
      // 纵览状态，请求外部栏目资讯
      getNewsListFromTotalPreview(columnData) {
        let data = {
          request: this.request,
          serveUrl: this.serveUrl,
          ColumnId: columnData.id ,
          kw: "",
          pageNo: this.pageNo,
          pageSize: 20,
          loadContent: false,
          loadPicContents: true,
          header: "portal"
        };
        getNewsList(data).then(res => {
          if (res.data && res.data.allContents) {
            let columnList = this.columnList.slice(1);
            columnList.forEach( (columnItem,columnIndex) => {
              if(columnItem.id === columnData.id) {
                let model = columnIndex === 0 ? 'simple' : '';
                //第一栏如果是小屏幕尺寸取this.heightSetting.smallScreen.firstModuleHeight，否则取this.heightSetting.bigScreen.firstModuleHeight，非第一屏取commonModuleHeight
                let moduleHeight = columnIndex === 0 ? this.screenSizeMore1720 ? this.heightSetting.bigScreen.firstModuleHeight : this.heightSetting.smallScreen.firstModuleHeight: this.heightSetting.commonModuleHeight;
                this.loadingsPreview[columnItem.id] = false;
                res.data.allContents.forEach( item => {
                  item.isNewNews = ifNewVisit(item.releaseStartTime,new Date().getTime(), 3*24*60*60*1000);
                  item.releaseStartTime = item.releaseStartTime && item.releaseStartTime.replace(/-/g, '/') || '';
                })
                this.newsOverPreviewList.splice(columnIndex, 1, this.getComputedNewsList(res.data.allContents,moduleHeight,model))
              }})
          }
        })}
      ,
      // 获取本应用打开的新闻列表
      handleGetNewsList() {
        this.loading1 = true;
        let data = {
          request: this.request,
          serveUrl: this.serveUrl,
          ColumnId:this.currentCategory.id || "",
          kw: "",
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          loadContent: false,
          loadPicContents: true,
          header: "portal"
        };
        getNewsList(data).then(res => {
          if (res.data && res.data.allContents) {
            this.loading1 = false;
            let allContents = res.data.allContents;
            this.totalCount = res.data.count;
            this.newsList = [];
            if(allContents && allContents.length > 0 && (allContents[0].columnId ===  this.currentCategory.id)) {
              allContents.forEach(item => {
                item.isNewNews = ifNewVisit(item.releaseStartTime,new Date().getTime(), 3*24*60*60*1000);
                item.releaseStartTime = item.releaseStartTime && item.releaseStartTime.replace(/-/g, '/') || '';
                this.newsList.push(item);
              });
            }
          }
        });
      },
      async getJumpUrlNewsList(columnData){
        if(!columnData) this.$message.error("参数错误！");
        let data = {
          request: this.request,
          serveUrl: this.serveUrl,
          header:"portal",
          ColumnId: columnData.id || "",
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        };
        this.loading1 = true;
        this.newsOverPreviewList = [];
        const res = await getRssContent(data);
        this.loading1 = false;
        let allContents = res.data && res.data.allContents || [];
        this.totalCount = res.data.count;
        this.newsList = [];
        if(allContents && allContents.length > 0 && (allContents[0].columnId ===  this.currentCategory.id)) {
          allContents.forEach(item => {
            item.isNewNews = ifNewVisit(item.releaseStartTime,new Date().getTime(), 3*24*60*60*1000);
            item.releaseStartTime = item.releaseStartTime && item.releaseStartTime.replace(/-/g, '/') || '';
            this.newsList.push(item);
          });
        }
      },
    }
  };
</script>
<style lang="scss" scoped>
  @import "@/styles/variables.scss";
  .newsNew {
    box-sizing: border-box;
    margin: 30px auto 50px;
    width: 1680px;
    /deep/ .el-loading-mask {
      border-radius: 6px;
    }
    @include portalMedia;
    .news-center-filter  {
      margin-bottom: 0px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-mode {
        cursor: pointer;
        color: #fff;
        margin-left: 20px;
      }

    }
    .newsNew-main-content {
      min-height: calc(100vh - 200px);
      margin-top: 30px;

      &-top {
        display: flex;
        .newsNew-content-left {
        }
        .newsNew-content-right {
          display: flex;
          flex-wrap: wrap;

        }
      }
      &-bottom {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        &-modules {
          margin-right: 20px;
          margin-top: 20px;
          width: 50%;
          &:nth-child(2n+1) {
            padding-right: 10px;
          }
          &:nth-child(2n) {
            padding-left: 10px;
          }

          &:nth-child(3n) {
            margin-right: 0px;
          }
        }

      }
    }

  }
  @media screen and (min-width: 1719px) {
    .newsNew-content-left  {
      margin-right: 20px;
    }
    .newsNew-content-right  {
      &-first {
        margin-right: 20px;
      }
      &-last {
        margin-top: 20px;
      }
    }
  }
  @media (max-width: 1719px){
    .newsNew {
      .newsNew-main-content {
        margin-top: 30px;
        &-bottom {
          &-modules {
            margin-right: 0px;
          }

        }
      }
    }

  }

</style>
